import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import ReactDOM from 'react-dom';
import { nextTick } from '@arco-design/mobile-utils';
export function toast(Component, type) {
  return function (originConfig) {
    var config = typeof originConfig === 'string' ? {
      content: originConfig,
      type: 'info'
    } : originConfig;

    if (type !== void 0) {
      config.type = type;
      config.loading = type === 'loading';
    }

    var div = document.createElement('div');
    document.body.appendChild(div);

    function render(props) {
      ReactDOM.render( /*#__PURE__*/React.createElement(Component, props), div);
    }

    function destory() {
      var onClose = config.onClose;
      onClose && onClose();
      var unmountResult = ReactDOM.unmountComponentAtNode(div);

      if (unmountResult && div.parentNode) {
        div.parentNode.removeChild(div);
      }
    }

    var dynamicProps = _extends({}, config, {
      close: close,
      getContainer: function getContainer() {
        return div;
      },
      onClose: destory,
      visible: false
    });

    var leaving = false;

    function update(newConfig) {
      dynamicProps = _extends({}, dynamicProps, newConfig);
      render(dynamicProps);
    }

    function close() {
      leaving = true;
      dynamicProps.visible = false;
      render(dynamicProps);
    }

    render(dynamicProps);
    nextTick(function () {
      // 在即将打开时发现已经调用了close则取消打开操作
      // @en When it is about to be opened, it is found that close has been called and the open operation is canceled
      if (leaving) return;
      dynamicProps.visible = true;
      render(dynamicProps);
    });
    return {
      update: update,
      close: close,
      hide: close
    };
  };
}